import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { TextArea } from '../elementos/ElementosDeFormulario';
import Boton from './Boton'

const VentanaModalText = ({textAreaMotivo, handleChange, mensajeHeader, mensajeBody, estadoModalText, setEstadoModalText, handleConfirm}) => {
    const handleClose = () => setEstadoModalText(false);

    return (
        <>
            <Modal show={estadoModalText} onHide={handleClose} animation={true}>
                <Modal.Header closeButton>
                    <p className='mb-0'>{mensajeHeader}</p>
                </Modal.Header>

                <Modal.Body>
                    <Form>
                        <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                            >
                            <Form.Label>{mensajeBody}</Form.Label>
                            <TextArea
                                name="textAreaMotivo"
                                value={textAreaMotivo}
                                onChange={handleChange}
                            />
                        </Form.Group>
                    </Form>
                </Modal.Body>

                <Modal.Footer>
                    <Boton onClick={handleClose}>Cancelar</Boton>
                    <Boton onClick={handleConfirm} variant="primary" primario="true">Confirmar</Boton>
                </Modal.Footer>
            </Modal>
    </>
    );
}
 
export default VentanaModalText;